import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getUserDetailsError, getUserDetailsSuccess, loginError, loginSuccess } from "../store/adminState/actions";
import auth from "../services/auth";
import { toast } from "react-toastify";

const SSORedirect: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        // Get code from URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get("code");

        if (!code) {
          throw new Error("No authorization code found");
        }

        // Exchange code for token
        const response = await auth.handleAuthCode(code);
        const token = response.data.bearerToken
        const userDetails = await auth.getUserDetails(token);

        dispatch(loginSuccess(token));
        dispatch(getUserDetailsSuccess(userDetails.data));

        // Redirect to main page
        history.push("/event-overview");
      } catch (error) {
        console.error("Error handling redirect:", error);
        if (error.response?.status === 401) toast.error("Sie sind nicht berechtigt, sich anzumelden.")
        if (error.response?.status !== 401) toast.error("Anmeldung fehlgeschlagen.")
        dispatch(loginError());
        dispatch(getUserDetailsError);
        history.push("/login");
      }
    };

    handleRedirect();
  }, [dispatch, history]);

  return (
    <div>
      <p>Authenticating...</p>
    </div>
  );
};

export default SSORedirect;
